<template>
  <div class="animated fadeIn">
    <basic-heading title="New Test Package" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'add test package'">
      <template #gated-content>
        <test-package-form @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import TestPackageForm from "@/components/lab/testpackage/form/TestPackageForm";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { testPackageNotifications } from "@/shared/notifications";

const TestPackageRepository = LabRepositoryFactory.get("testPackage");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "TestPackageAdd",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    TestPackageForm,
  },
  data() {
    return {
      laboratory_id: this.$store.getters.getLaboratoryContext.id,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/testpackages",
            title: "Test package list",
          },
        ],
      };
    },
  },
  methods: {
    async submit(form_data) {
      const payload = {
        ...form_data,
        laboratory_id: this.laboratory_id,
      };

      try {
        const { data } = await TestPackageRepository.create(payload);
        this.addSuccess();
        this.$router.push(`/testpackages/${data.id}`);
      } catch ({ response }) {
        this.addFail();
      }
    },
  },
  notifications: testPackageNotifications,
};
</script>
